// extracted by mini-css-extract-plugin
module.exports = {"Heading":"Heading_Heading__1sOu4","SmallBorder":"Heading_SmallBorder__3SiCx"};